<script setup>
import {trackerTypes} from "@/constants/trackers";
import {getAvatarsForDisplay, getNoun, getPermissionNamesForDisplay} from "../../../../helpers/string";
import Avatar from "vue-avatar";
import trackersFoldersService from "@/services/trackers-folders.service";
import {ref, inject} from "vue";
import EditFolder from "@/components/trackers/EditFolder.vue";

const props = defineProps(['folder']);
const updateData = inject('updateData');
const id = props.folder.id;
const editFolderModal = ref(null);

async function remove() {
    if (!confirm('Remove folder?')) {
        return;
    }

    await trackersFoldersService.delete(id);
    updateData();
}

async function archive() {
    if (!confirm("Archive folder and all it's trackers?")) {
        return;
    }

    await trackersFoldersService.archive(id);
    updateData();
}

async function unarchive() {
    if (!confirm("Unarchive folder and all it's trackers?")) {
        return;
    }

    await trackersFoldersService.unarchive(id);
    updateData();
}

</script>

<template>
    <b-col md="6" lg="4">
        <div class="card card--bordered">
            <header class="card__header">
                <h5 class="heading5 mb-0">
                    <router-link :to="'/trackers/folder/' + folder.id">{{ folder.name }}</router-link>
                </h5>

                <b-dropdown
                    v-if="folder.user_permissions.includes('tracker-folder-manage')"
                    class="dropdown-original dropdown-original--middle icons-list dropdown-small ml-auto dropdown-classic"
                    boundary="viewport"
                >
                    <b-dropdown-item class="icons-list__edit" @click="editFolderModal.open(folder.id)">
                        Edit Folder
                    </b-dropdown-item>

                    <b-dropdown-item class="icons-list__delete" @click="remove">
                        Delete
                    </b-dropdown-item>

                    <b-dropdown-item class="icons-list__archive" v-if="!folder.archived" @click="archive">
                        Archive
                    </b-dropdown-item>

                    <b-dropdown-item class="icons-list__archive" v-else @click="unarchive">
                        Unarchive
                    </b-dropdown-item>
                </b-dropdown>
            </header>

            <div class="card__collapse">
                <header class="card__collapse__header">
                    <h5 class="heading5 heading5--secondary">
                        <template v-if="folder.type === trackerTypes.PUBLIC">
                            <span class="heading5__folder heading5__folder--public">Public Collection</span>
                        </template>

                        <template v-else>
                            <span class="heading5__folder">Folder</span>
                        </template>
                        &bull; {{folder.trackers_count}} {{getNoun('tracker', folder.trackers_count)}}
                    </h5>

                    <b-button
                        v-if="folder.permissions.length || folder.description.length"
                        v-b-toggle="'folder-details-' + folder.id"
                        class="card__collapse__button"
                    >
                        Details
                    </b-button>
                </header>

                <b-collapse v-if="folder.permissions.length || folder.description.length" :id="'folder-details-' + folder.id">
                    <p>{{ folder.description }}</p>

                    <b-dropdown class="dropdown--secondary" variant="link" toggle-class="text-decoration-none" no-caret>
                        <template #button-content>
                            <div class="section-users section-users--limited">
                                <div class="section-users__images">
                                    <div
                                        v-for="(item, index) in getAvatarsForDisplay(folder.permissions)"
                                        :key="index"
                                        class="section-users__images__item"
                                    >
                                        <Avatar
                                            v-if="item.type === 'user'"
                                            :src="item.avatar"
                                            :username="item.name"
                                            :size="26"
                                        />
                                    </div>
                                </div>

                                <p>
                                    <span class="section-users__data">
                                        <a v-for="(item, index) in getPermissionNamesForDisplay(folder.permissions)" :key="index">
                                            {{item}}
                                        </a>
                                    </span>
                                </p>
                            </div>
                        </template>

                        <b-dropdown-header>
                            <header class="dropdown__header-inner">
                                <h4 class="heading4">Users in {{ folder.name }}</h4>

                                <a v-if="false" href="#" class="link link--lg">Edit</a>
                            </header>

                            <ul class="rows-list">
                                <li  v-for="(permission, index) in folder.permissions" :key="index">
                                    <div class="rows-list__avatar">
                                        <Avatar
                                            :username="permission.name"
                                            :src="permission.avatar"
                                            :size="30"
                                        />
                                    </div>

                                    <h5 class="heading5 heading5--secondary">{{ permission.name }}</h5>
                                    <p class="ml-auto">{{ permission.role.name }}</p>
                                    <a class="link-info" v-b-popover.hover.top="permission.role.description" title=""></a>
                                </li>
                            </ul>
                        </b-dropdown-header>
                    </b-dropdown>
                </b-collapse>
            </div>
        </div>

        <EditFolder
            ref="editFolderModal"
            @folderSaved="updateData"
        />
    </b-col>
</template>

<style scoped>

</style>
